var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentView !== false)?_c('div',{staticClass:"tutorials",style:(_vm.styleObject),on:{"click":function($event){return _vm.remove()}}},[_c('transition',{attrs:{"name":"fade"}},[_c(_vm.currentView,{tag:"component"})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688f4779","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorials/Tutorials.vue
// module id = 302
// module chunks = 0